export default{
    urologyPhysicalExamType: "Type",
    genealogyPhysicalExamType: "Genealogy Type",
    varicocelePhysicalExamType: "Varicocele Type",
    hydrosolPhysicalExamType: "Hydrosol Type",
    herniPhysicalExamType: "Herni Type",
    varicoceleGrade: "Varicocele Grade",
    description: "Description",
}